module.exports = __webpack_public_path__ + "img/illustrations-storebatch.e6e88133.svg";